import GnForm from "../../../../../components/GnForm/index.js";
import {Button, InputNumber, Modal, Row, Space, Table} from "../../../../../../__snowpack__/pkg/antd.js";
import _ from "../../../../../../__snowpack__/pkg/lodash.js";
import Column from "../../../../../../__snowpack__/pkg/antd/lib/table/Column.js";
import React, {useEffect, useMemo, useState} from "../../../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../../../__snowpack__/pkg/react-intl.js";
import qs from "../../../../../../__snowpack__/pkg/query-string.js";
import {Tip} from "../../../../../components/Tip/index.js";
import {EditOutlined} from "../../../../../../__snowpack__/pkg/@ant-design/icons.js";
import {useLayoutState} from "../../../../../store/layout.js";
import {useUpdateRoute} from "../../../../../lib/useIframe.js";
export const EditMultWarehouseStock = ({variationList, visible, close, setVariationList, warehouseList}) => {
  const {formatMessage} = useIntl();
  const [form] = GnForm.useForm();
  const [stockList, setStockList] = useState(variationList);
  const [batchStockInputValue, setBatchStockInputValue] = useState();
  const isDraft = useMemo(() => qs.parse(window.location.search).status === "DRAFT", [window.location.search]);
  const {withPermission} = useLayoutState();
  const {updateRoute} = useUpdateRoute();
  useEffect(() => {
    init();
  }, [variationList, warehouseList]);
  const init = () => {
    if (warehouseList.length > 0) {
      const stockList2 = [];
      variationList.map((variation) => {
        if (variation.warehouseInfos && variation.warehouseInfos.length > 0) {
          variation.warehouseInfos?.map((warehouse, index) => {
            stockList2.push({
              ...warehouse,
              stockManuallyEditable: variation.stockManuallyEditable,
              masterVariationSku: variation.masterVariationSku,
              sku: variation.sku,
              variantName: variation.name || variation.variantName,
              firstStock: index === 0 ? true : false,
              id: variation.id,
              warehouseEditable: warehouse.warehouseEditable || !variation.id || (warehouse.newWarehouse || isDraft ? true : false)
            });
          });
        } else {
          const defaultWarehouse = warehouseList.find((warehouse) => warehouse.isDefault === 1) || warehouseList[0];
          stockList2.push({
            stockManuallyEditable: true,
            externalWarehouseId: defaultWarehouse.warehouseId,
            variantName: variation.name || variation.variantName,
            stock: variation.stock,
            firstStock: true,
            warehouseEditable: true,
            newWarehouse: true
          });
        }
      });
      setStockList(stockList2);
    }
  };
  const handleApplyAll = () => {
    const data = form.getFieldsValue();
    for (const [k, v] of Object.entries(data)) {
      if (k.includes("stock")) {
        data[k] = batchStockInputValue;
      }
    }
    setStockList(stockList.map((item) => {
      item.stock = batchStockInputValue;
      return item;
    }));
    form.setFieldsValue(data);
  };
  const closeModal = () => {
    close();
  };
  return /* @__PURE__ */ React.createElement(Modal, {
    maskClosable: false,
    width: 800,
    title: formatMessage({id: "editMultiwarehouseStock"}),
    visible,
    onOk: () => {
      form.validateFields().then(() => {
        setVariationList(variationList.map((variation) => {
          variation.stock = stockList.filter((item) => item.variantName === variation.name).reduce((pre, cur) => {
            return pre + (_.isNumber(cur.stock) ? cur.stock : 0);
          }, 0) || 0;
          variation.warehouseInfos = stockList.filter((item) => {
            return (item.variantName || item.name) === (variation.name || variation.variantName);
          });
          return variation;
        }));
        closeModal();
      });
    },
    onCancel: () => {
      closeModal();
    }
  }, /* @__PURE__ */ React.createElement(GnForm, {
    form,
    onFinish: (values) => {
    }
  }, /* @__PURE__ */ React.createElement(Space, {
    style: {marginBottom: 16}
  }, /* @__PURE__ */ React.createElement("span", {
    style: {marginLeft: 12}
  }, formatMessage({id: "MassEditStock"}), ":"), /* @__PURE__ */ React.createElement(InputNumber, {
    value: batchStockInputValue,
    maxLength: 5,
    parser: (value) => {
      return String(value ?? "").replace?.(/\D/g, "");
    },
    min: 0,
    style: {width: 160},
    onChange: (value) => setBatchStockInputValue(value)
  }), /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    onClick: handleApplyAll
  }, formatMessage({id: "ApplyToAll"}))), /* @__PURE__ */ React.createElement(Table, {
    dataSource: stockList,
    pagination: false
  }, /* @__PURE__ */ React.createElement(Column, {
    title: formatMessage({id: "variationName"}),
    dataIndex: "name",
    key: "name",
    render: (name, record, index) => {
      if (record.firstStock) {
        return record.name || record.variantName;
      }
    }
  }), /* @__PURE__ */ React.createElement(Column, {
    title: formatMessage({id: "totalStock"}),
    dataIndex: "stock",
    key: "stock",
    render: (name, record) => {
      if (record.firstStock) {
        return stockList.filter((item) => item.variantName === record.variantName).reduce((pre, cur) => {
          return pre + (_.isNumber(cur.stock) ? cur.stock : 0);
        }, 0) || 0;
      }
    }
  }), /* @__PURE__ */ React.createElement(Column, {
    title: formatMessage({id: "warehousename"}),
    render: (item, record) => {
      const randomNumber = record.warehouseRandomNumber || Math.random() * 1e5;
      record.warehouseRandomNumber = randomNumber;
      const disabledWarehouse = [];
      stockList.map((item2) => {
        if (item2.variantName === record.variantName) {
          disabledWarehouse.push(item2.externalWarehouseId || item2.warehouseId);
        }
      });
      return /* @__PURE__ */ React.createElement(GnForm.Item, {
        name: `${record.id}-warehouse-${randomNumber}`,
        prefabKey: "Select",
        className: "inline-explain",
        initialValue: record.externalWarehouseId || record.warehouseId,
        rules: [
          {
            required: true
          }
        ],
        componentProps: {
          disabled: !record.warehouseEditable,
          onChange: (value) => {
            setStockList(stockList.map((item2) => {
              if (record.id === item2.id) {
                record.externalWarehouseId = value;
              }
              return item2;
            }));
          },
          options: [
            ..._.uniqBy(warehouseList, "warehouseId").map((warehouse) => {
              return {
                label: warehouse.warehouseName,
                value: warehouse.warehouseId,
                disabled: warehouse.warehouseStatus === "DISABLED" || disabledWarehouse.includes(warehouse.warehouseId)
              };
            })
          ]
        }
      });
    }
  }), /* @__PURE__ */ React.createElement(Column, {
    title: formatMessage({id: "Stock"}),
    render: (item, record) => {
      const randomNumber = record.stockRandomNumber || Math.random() * 1e5;
      record.stockRandomNumber = randomNumber;
      if (!record.stockManuallyEditable) {
        return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Tip, {
          tip: formatMessage({id: "hasbinded"}, {sku: record?.sku}),
          bgcolor: "#ADBACC"
        }), "\xA0", record.stock, /* @__PURE__ */ React.createElement(Button, {
          type: "link",
          icon: /* @__PURE__ */ React.createElement(EditOutlined, null),
          onClick: () => {
            if (withPermission("inventory-management-2.0")) {
              updateRoute(`stock-manage-local?isku=${record?.masterVariationSku}`);
            } else {
              updateRoute("stock-manage");
            }
          }
        }));
      }
      return /* @__PURE__ */ React.createElement(Row, {
        align: "middle"
      }, /* @__PURE__ */ React.createElement(GnForm.Item, {
        name: `${record.id}-stock-${randomNumber}`,
        prefabKey: "InputNumber",
        className: "inline-explain",
        initialValue: record.stock || 0,
        rules: [
          {
            min: 0,
            max: 99999,
            type: "number",
            message: formatMessage({
              id: "tiktokstocktLimitOhters"
            })
          },
          {
            required: true
          }
        ],
        componentProps: {
          onChange: (value) => {
            setStockList(stockList.map((item2) => {
              if (record.id === item2.id) {
                record.stock = value;
              }
              return item2;
            }));
          },
          maxLength: 6,
          formatter: (value) => String(value ?? "").replace?.(/\D/g, ""),
          min: 0
        }
      }));
    }
  }), /* @__PURE__ */ React.createElement(Column, {
    title: formatMessage({id: "Action"}),
    key: "action",
    render: (value, record, index) => {
      const addBtnDisable = stockList.filter((item) => item.variantName === record.variantName).length === warehouseList.length;
      return /* @__PURE__ */ React.createElement(Space, {
        size: "middle"
      }, record.firstStock && /* @__PURE__ */ React.createElement(Button, {
        type: "link",
        disabled: addBtnDisable,
        style: {padding: 0},
        onClick: () => {
          const tmp = [...stockList];
          const lastIndex = _.findLastIndex(tmp, {variantName: record.variantName});
          tmp.splice(lastIndex + 1, 0, {
            ...record,
            edited: true,
            stockRandomNumber: void 0,
            warehouseRandomNumber: void 0,
            newStock: 0,
            stock: 0,
            externalWarehouseId: void 0,
            warehouseId: void 0,
            firstStock: false,
            warehouseEditable: true,
            stockManuallyEditable: true
          });
          setStockList(tmp);
        }
      }, formatMessage({id: "add2"})), record.edited && /* @__PURE__ */ React.createElement(Button, {
        type: "link",
        disabled: stockList.length === 1,
        style: {padding: 0},
        onClick: () => {
          const tmp = [...stockList];
          tmp.splice(index, 1);
          setStockList(tmp);
        }
      }, formatMessage({id: "delete1"})));
    }
  }))), /* @__PURE__ */ React.createElement("p", {
    style: {marginTop: 10}
  }, formatMessage({id: "totalStock"}), ":", " ", stockList.reduce((pre, cur) => pre + (_.isNumber(cur.stock) ? cur.stock : 0), 0)));
};
